import { ProductTransaction } from '../types/productTransaction';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/product_transaction/list';

export namespace ProductTransactionRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<ProductTransaction>> => {
    return (await http.post(LIST, payload)).data;
  };
}
